<template>
  <div>
    <v-row class="mt-3"><h5 class="text--disabled">Device Fleets</h5></v-row>
    <v-row><v-divider /></v-row>
    <v-row>
      <videon-state-tile
        v-if="loading"
        heading=""
      >
        <span class="text--disabled">loading...</span>
      </videon-state-tile>

      <videon-state-tile
        v-else-if="error"
        heading=""
      >
        <span class="error--text">{{ errorText }}</span>
      </videon-state-tile>

      <videon-state-tile
        v-else-if="fleetGuids.length === 0"
        heading=""
      >
        <span class="text--disabled">None</span>
      </videon-state-tile>

      <template v-else>
        <videon-state-tile
          v-for="fleetGuid in fleetGuids"
          :key="fleetGuid"
          heading=""
        >
          <router-link
            class="info--text text-decoration-none"
            style="cursor: pointer;"
            :to="{ name: 'View Fleet', params: { fleet_guid: fleetGuid } }"
          >{{ fleetDisplayName(fleetGuid) }}</router-link>
        </videon-state-tile>
      </template>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DeviceFleetsSection',

  props: {
    device_guid: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      fleetGuids: [],
      loading: false,
      error: false,
      errorText: '',
    }
  },

  mounted() {
    this.loadFleets()
  },

  methods: {
    fleetDisplayName(fleetGuid) {
      if (!fleetGuid) {
        return ''
      }
      const fleet = this.$fleets.getFleet(fleetGuid)
      return fleet ? fleet.displayName() : 'loading...'
    },

    async loadFleets() {
      if (!this.device_guid) {
        return
      }

      this.loading = true
      this.error = false
      this.errorText = ''

      try {
        const guids = []
        let paginationToken = null

        do {
          const params = { pagination_size: 50 }
          if (paginationToken) {
            params.pagination_token = paginationToken
          }

          const response = await this.axios.get(
            '/devices/' + this.device_guid + '/fleets',
            { params }
          )

          const page = (response.data && response.data.fleets) || []
          page.forEach((row) => {
            if (row.fleet_guid) {
              guids.push(row.fleet_guid)
              this.$fleets.getFleet(row.fleet_guid)
            }
          })
          paginationToken = response.data && response.data.pagination_token
        } while (paginationToken)

        this.fleetGuids = guids
      } catch (err) {
        this.error = true
        this.errorText = this.$helpers.parseError(err)
        this.fleetGuids = []
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
